import { useSyncExternalStore } from "react"
import type { Device } from "@/lib/install-targets"

function detectBrowser(): string {
  const ua = navigator.userAgent.toLowerCase()
  if (ua.includes("chrome") && !ua.includes("edg")) return "chrome"
  if (ua.includes("firefox")) return "firefox"
  if (ua.includes("safari") && !ua.includes("chrome") && !ua.includes("crios")) return "safari"
  return "chrome"
}

// Returns a primitive string (not an object) so the snapshot stays referentially
// stable for useSyncExternalStore — an object literal would change identity every
// call and trigger an infinite render loop.
function detectDevice(): Device {
  const ua = navigator.userAgent
  // iPadOS 13+ reports as "Macintosh"; detect it via touch support.
  if (/iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1)) {
    return "ios"
  }
  if (/Android/i.test(ua)) return "android"
  return "desktop"
}

const subscribe = () => () => {}

export function useBrowser() {
  return useSyncExternalStore(subscribe, detectBrowser, () => "chrome")
}

/**
 * Client device class (`ios` | `android` | `desktop`). SSR + first client render
 * return the stable `"desktop"` default; React patches to the real value
 * post-hydration (brief flash, no hydration mismatch). Combine with `useBrowser()`
 * and pass both to `resolveInstallTarget`.
 */
export function useDevice(): Device {
  return useSyncExternalStore(subscribe, detectDevice, () => "desktop")
}
